
<template>

    <div class="order">
        <b-modal ref="single-order" id="single-order" hide-footer :title="title">
            <div class="d-block text-center">
                <h3>Ordered products:</h3>

                <ol v-if="order">
                    <li v-for="(product, id) in order.products" :key="id">
                        {{product.name}} x {{product.pivot.quantity}} at ${{product.pivot.price}}
                    </li>
                </ol>

                <h2>TOTAL : ${{total}}</h2>
            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Close</b-button>
        </b-modal>
    </div>

</template>

<script>
export default {
    computed: {
        order() {
            return this.$store.getters.ORDER
        },
        total() {
            return  this.order ? this.order.total : 0
        },
        title() {

            if(!this.order) return ''

            var title = `Order  ${this.order.id} | `

            if(!this.order.processed) {
                title += `Waiting for processing`
            } else if(this.order.processed && !this.order.fulfilled) {
                title += `Ready for collection`
            } else if(this.order.processed && this.order.fulfilled) {
                title += `Completed`
            }

            return title
        }
    },
    methods: {
        hideModal() {
            this.$refs['single-order'].hide()
            this.$store.dispatch('RESET_CURRENT_ORDER')
        },
    },
}
</script>